/****************************************************
 * Module Name:  giaLabStatsPieChart.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React from "react";
import { useState } from "react";
import Constants from "../../utility/constants";
import { useEffect } from "react";
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Paper,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from "recharts";
import CommonSnackbar from "../common/commonSnackBar";
import Utility from "../../utility/utility";
import { FaUser } from "react-icons/fa";
import WorkerProxy from "../../utility/proxy/worker/workerProxy";

let useColor = Utility.GetRandomColorForPieChart();

const GiaLabStatsPieChart = () => {

    const [chartData, setChartData] = useState([]);
    const [errorSnackbar, setErrorSnackbar] = useState(false);

    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down("md"));

    useEffect(() => {
        handleSearch();
    }, []);

    const handleLegends = (value, entry) => {
        return entry.payload.status;
    };

    const handleSearch = () => {
        WorkerProxy.GetAllGiaStats((response) => {
            if (response) {
                setChartData(response);
            } else {
                setErrorSnackbar(true);
            }
        });
    };

    function CustomTooltip({ payload, active }) {
        if (active) {
            const data = payload[0].payload;
            return (
                <Box bgcolor={"#FFFFF7"} padding={2} sx={{ opacity: 0.8 }}>
                    <Typography>
                        {data.status} <br />
                        Count :{data.count}
                    </Typography>
                </Box>
            );
        }
        return null;
    }

    return (
        <div>
            <CommonSnackbar
                show={errorSnackbar}
                message={Constants.APiFailErrorMessage}
                variant={"error"}
                autoHide={Constants.SnackBarCloseTimer}
                title={"Failed"}
                handleClose={() => setErrorSnackbar(false)}
            />
            <Paper elevation={4}>
                <Card>
                    <CardHeader
                        avatar={<FaUser size={25} color={useColor[1 % useColor.length]} />}
                        title={
                            <Typography
                                component="span"
                                fontWeight={Constants.defaultFontWeight}
                                fontSize={"1.25rem"}
                            >
                                GIA Stats
                            </Typography>
                        }
                        subheader="GIA Status count group by status"
                    />
                    <CardContent>
                        <Box height={matches ? 300 : 500} width={matches ? 320 : 550}>
                            <ResponsiveContainer width="99%">
                                <PieChart>
                                    <Pie
                                        data={chartData}
                                        labelLine={true}
                                        label
                                        fill="#8884d8"
                                        dataKey="count"
                                        stroke="#000000"
                                        strokeWidth={1}
                                    >
                                        {chartData.map((entry, index) => (
                                            <Cell
                                                key={`cell-${index}`}
                                                fill={useColor[index % useColor.length]}
                                            />
                                        ))}
                                    </Pie>
                                    <Tooltip content={<CustomTooltip />} />
                                    <Legend formatter={handleLegends} />
                                </PieChart>
                            </ResponsiveContainer>
                        </Box>
                    </CardContent>
                </Card>
            </Paper>
        </div>
    );
};

export default GiaLabStatsPieChart;
